import styles from './Payment.module.css'
import React, {useEffect, useRef, useState} from "react";
import useApiQuery from "../../ApiQuery/UseApiQuery";
import IframeResizer from 'iframe-resizer-react'
import {PersonalDataInt} from "../PersonalData/PersonalData";
import WaitLoader from "../../WaitLoader/WaitLoader";
import ReactDOM from 'react-dom'
import ModalWindow from "../../FormTemplate/ModalWindow/ModalWindow";
import imSBP from '../../Img/Payment/sbp.svg'
import imMir from '../../Img/Payment/mir.svg'
import imVisa from '../../Img/Payment/visa.svg'
import imMaster from '../../Img/Payment/mastercard.svg'
import imMaestro from '../../Img/Payment/maestro.svg'
import imHalva from '../../Img/Payment/halva.svg'
import {useDispatch, useSelector} from "react-redux";
import {ReduxStateInt, setOrderData} from "../../Reducer/GlobalReducer";
import useLongTask from "../../Util/LongTaskItem/UseLongTask";
import useTimerTask from "../../Util/TimerItem/UseTimerTask";
import ErrorLineItem, {ErrorLineItemRef} from "../../FormTemplate/ErrorLineItem/ErrorLineItem";


export interface NeedPaymentInt
{
    orderId?:string
    sessionId?:string
}

export interface PaymentInt
{
    orderId:string
    paymentType: string
}

interface NextButtonCallBackInt
{
    (data:PaymentInt):void
}

export interface PaymentPropsInt
{
    cbExecute: NextButtonCallBackInt
}

export default function Payment({cbExecute}:PaymentPropsInt)
{
    const baseUrl = useSelector((state: ReduxStateInt) => {
        return state.baseUrl
    })


    const dispatch = useDispatch()
    const orderData = useSelector((state: ReduxStateInt) => {
        return state.orderData
    })
    const errorLineRef = useRef<ErrorLineItemRef>(null)

    const [orderId,setOrderId] = useState( "")
    const [startCheckPayment, stopCheckPayment] = useTimerTask((e:any)=>tickCheckPayment(e),45,6000)

    const mainRef = useRef<HTMLDivElement>(null)

    const [payment, setPayment] = useState<PaymentInt>({
        orderId:"",
        paymentType:""
    })


    const [frLdr, setFrLdr] = useState(true)
    const [stage,setStage] = useState(0)

    const [pmUrl, setPmUrl]=useState("")
    const [pmAmount, setPmAmount] = useState(0)

    const { innerWidth: width, innerHeight: height } = window;
    const [pmWinHeight, setPmWinHeight] = useState(0)

    const [pmType,setPmType] = useState(0)



    const needPaymentData = useRef<NeedPaymentInt>()
    const [ldrNeedPayment,rsNeedPayment,exNeedPayment] = useApiQuery("/payment/need","post",needPaymentData);



    const pmUrlData = useRef<PaymentInt>({
        paymentType:"",
        orderId:""
    })
    const [ldrPmUrl,rsPmUrl,exPmUrl] = useApiQuery("/payment/url","post",pmUrlData);


    const pmCheckData = useRef(
        {
            orderId:""
        }
    )
    const [ldrPmCheck,rsPmCheck,exPmCheck] = useApiQuery("/payment/state","post",pmCheckData);

    useEffect(()=>{
        window.addEventListener('message',handleMessage)
        return ()=>{
            window.removeEventListener('message',handleMessage)
        }
    },[])


    const handleMessage = (e: any)=>{
        const x = e?.data
        if(x?.state)
        {
            setStage(4)
        }

        console.log("messageFromFrame",e)
    }


    useEffect(()=>{
        if(orderData?.orderId)setOrderId(orderData?.orderId)
    },[orderData])

    useEffect(()=>{
        setPmWinHeight(Math.floor(height*0.8))//Расчет высоты для фрейма
    },[height])

    useEffect(()=>{
        switch (stage)
        {
            case 0:
                checkNeedPayment()
                break
            case 2://Ошибка
                stopCheckPayment()
                break
            case 1://Кликнули оплатить
                loadUrl()
                break
            case 3://Загрузился iFrame
                //checkPayment(orderId)
                break
            case 4: //Платеж прошел
                setFrLdr(true)
                dispatch(setOrderData({...orderData,paymentData: {
                        paymentType: pmType === 0 ? "SBP" : "ACQUIRING",
                        amount:pmAmount
                    }}))
                stopCheckPayment()
                setTimeout(()=>{
                    if(cbExecute)cbExecute(payment)
                },2000)
                break
            case 5://Платеж не нужен
                dispatch(setOrderData({...orderData,paymentData: {
                        paymentType: "ZERO",
                        amount:0
                    }}))
                if(cbExecute)cbExecute(payment)
                break

            default:
        }

    },[stage,pmUrlData])


    const checkNeedPayment = () =>{
        needPaymentData.current = {
            orderId: orderData?.orderId,
            sessionId: orderData?.sessionId
        }

        exNeedPayment().then((e)=>{
            if(e.success)
            {
                if(e?.payload?.needPay !== undefined && !e?.payload?.needPay)
                {
                    setStage(5)
                }
            }
        }).catch((e)=>{

        })
    }


    const tickCheckPayment = (data: any) =>{
        console.log("tick",data)
        pmCheckData.current = {
            orderId:orderId
        }
        exPmCheck().then((e)=>{
            try {
                if(e?.success) {
                    console.log("check data",e)
                    if(e?.payload?.state === 1)
                    {
                        setStage(4)
                    }
                    return;
                }
                if(errorLineRef.current)errorLineRef.current.show(e?.errorAsString ? e?.errorAsString  : "Ошибка сервера",true,3000)

            } catch (e){ console.log(e)}


        }).catch((e)=>{
            if(errorLineRef.current)errorLineRef.current.show(e?.errorAsString ? e?.errorAsString  : "Ошибка сервера",true,3000)
        })


    }



    const loadUrl = ()=>{
        const orderId = orderData?.orderId ? orderData?.orderId : "999"
        pmUrlData.current = {
            orderId: orderId,
            paymentType: pmType === 0 ? "SBP" : "ACQUIRING"
        }

        setPayment(pmUrlData.current)

        exPmUrl().then((e)=>{
            if(e?.success)
            {
                console.log("url data ",e?.payload)
                setPmUrl(e?.payload?.url)
                setPmAmount(e?.payload?.amount)
                startCheckPayment()
                setStage(3)
                return
            }
            if(e?.code === 1) {
                setStage(4)//Уже оплачен
                return;
            }
            setStage(0)
            if(errorLineRef.current)errorLineRef.current.show(e?.errorAsString ? e?.errorAsString  : "Ошибка сервера",true,0)
        }).catch((e)=>{
            setStage(0)
            if(errorLineRef.current)errorLineRef.current.show(e?.errorAsString ? e?.errorAsString  : "Ошибка сервера",true,0)
        })
    }

    const pmClose = ()=>{
        setStage(0)
        setFrLdr(true)
        stopCheckPayment()
    }


    return(
        <div className={styles.payCont} ref={mainRef}>
            <WaitLoader loading={ldrNeedPayment} api={rsNeedPayment} onlyLoading={true}>
                {stage >= 0 &&
                    <div className={styles.pmTypeCont}>
                        <div className={styles.pmTitle}>
                            Выберите способ оплаты
                        </div>
                        <div className={styles.pmTypeSelector}>
                            <div className="form-check">
                                <div className={styles.pmSelLine}>
                                    <div className={styles.pmRadio}>
                                        <input className="form-check-input" type={"radio"} name={"pmMode"} value={"sbp"} checked={pmType === 0} id={"spb"}
                                               onClick={()=>setPmType(0)}
                                               onChange={()=>{}}
                                        ></input>
                                        <label className="form-check-label" htmlFor={"spb"}>Система быстрых платежей</label>
                                    </div>
                                    {pmType === 0 &&
                                        <div className={styles.pmLineImg}>
                                            <div className={styles.pmImList}>
                                                <img src={imSBP}></img>
                                            </div>
                                            <p className={styles.pmItemText}>Оплата заказа по QR-коду или по ссылке. Мгновенное зачисление.Неважно какой банк, главное, чтобы он был подключен к СБП.</p>
                                        </div>
                                    }
                                </div>
                                <div className={styles.pmSelLine}>
                                    <div className={styles.pmRadio}>
                                        <input className="form-check-input" type={"radio"} name={"card"} value={"sbp"}  id={"card"} checked={pmType === 1}
                                               onClick={()=>setPmType(1)}
                                               onChange={()=>{}}
                                        ></input>
                                        <label className="form-check-label" htmlFor={"card"}>Банковская карта</label>
                                    </div>
                                    {pmType === 1 &&
                                        <div className={styles.pmLineImg}>
                                            <div className={styles.pmImList}>
                                                <img src={imMir}></img>
                                                <img src={imVisa}></img>
                                                <img src={imMaster}></img>
                                                <img src={imMaestro}></img>
                                                <img src={imHalva}></img>
                                            </div>
                                            <p className={styles.pmItemText}>Принимаются к оплате карты Visa, MasterCard, Maestro, МИР, карта рассрочки «Халва».
                                                Оплата осуществляется в защищенном режиме через платежный шлюз Райфайзен банка.</p>
                                        </div>
                                    }
                                </div>
                            </div>

                            <div className={styles.pmSelLineSell}>

                                <div>Нажимая оплатить Вы принимаете <a href={baseUrl + '/static/refund-politic.docx'} target={"_blank"}>политику возвратов</a></div>
                            </div>
                        </div>
                        <div className={styles.btnLine}>

                            <button type="button" className="btn btn-face"
                                    disabled={(stage === 1 || stage ===4 )}
                                    onClick={()=>setStage(1)}
                            >Оплатить</button>
                            {stage === 1 &&
                                <WaitLoader loading={ldrPmUrl } api={rsPmUrl} onlyLoading={true}>
                                </WaitLoader>

                            }
                        </div>

                    </div>
                }


                <ErrorLineItem ref={errorLineRef} ></ErrorLineItem>


                {stage === 3 &&
                    <ModalWindow onClose={()=>pmClose()}>

                        <div className={styles.frameCont} style={{height: pmWinHeight+"px"}}>
                            <div style={{position:"absolute"}}>
                                <WaitLoader loading={frLdr} api={rsPmUrl} onlyLoading={true}>
                                    <></>
                                </WaitLoader>
                            </div>

                            {!frLdr &&
                                <div className={styles.pmCloseCont}>
                                    <div className={styles.pmClose}
                                         onClick={()=>pmClose()}
                                    >
                                        Закрыть
                                    </div>
                                </div>

                            }
                            <iframe className={styles.ifPayment} src={pmUrl} frameBorder={0}
                                    height={pmWinHeight-50+ "px"}
                                    onLoad={(e)=>
                                    {
                                        setFrLdr(false)
                                        window.scrollTo({top:0})
                                        if(mainRef !==null )mainRef?.current?.scrollIntoView()
                                    }}
                            ></iframe>

                        </div>
                    </ModalWindow>

                }
                { stage === 4  &&
                    <div className={styles.goodPay}>платеж принят</div>
                }

            </WaitLoader>


        </div>
    )
}

